import styled from "styled-components";
import { useEffect } from "react";
import { Picks } from "@low6dev/react-feature-picks/dist";
import { useSelector, useDispatch } from "react-redux";
import { useTranslations, useCheckAuth } from "hooks";
import { openDrawer } from "components/feature/drawer/actions";
import { placeBet, setAuth } from "components/feature/auth/actions";
import { setBetbarParent } from "components/feature/betbar/actions";
import { createImageCdnLink } from "@low6dev/react-utils/dist";
import history from "router/history";

import {
  TotoPopupBannerDick2022,
  TotoGameBannerDick2022,
} from "@low6dev/react-shared-banners";

const StyledWrapper = styled.section`
  padding: ${(p) => (p.needsPaddingTop ? "3rem" : "2rem")} 0;
`;

const StyledBanner = styled.img`
  width: ${process.env.REACT_APP_PICKS_GAME_LOGO_WIDTH || "55%"};
  display: block;
  margin: ${process.env.REACT_APP_PICKS_GAME_LOGO_MARGIN || "2.5rem auto 0"};
`;

const StyledTotoBannerLink = styled.a``;

const StyledTotoBannerImage = styled.img`
  width: 100%;
`;

const Wrapper = ({ setPicksData, isClearingPicks, onPicksCleared }) => {
  const dispatch = useDispatch();

  useCheckAuth();

  const app = useSelector((s) => s.app);

  const { isLoggedIn, isOver24 } = useSelector((s) => s.auth);

  const { language, profile } = app;

  const betbarParent = useSelector((s) => s.betbarParent);

  const { activePickem, activePickemList, isPopupVisible } = betbarParent;

  const [translations] = useTranslations();

  const handlePicksChanged = (params) => {
    const { picks } = params;

    console.log("picks", picks);

    let xtremepushData = {};

    activePickem?.questions?.map((obj, index) => {
      console.log("options", obj?.options);
      console.log("optionId", obj.id);

      xtremepushData[`Question${index + 1}Question`] = obj?.label;
      xtremepushData[`Question${index + 1}Answer`] =
        obj?.options?.find((opt) => opt.id === picks[obj.id])?.label || "";

      return null;
    });

    dispatch(
      setAuth({
        xtremepushData,
      })
    );

    setPicksData(params);
  };

  const handleSetBetbarParent = (betbar) => {
    dispatch(setBetbarParent(betbar));
  };

  const handlePlaceBetSuccess = () => {
    console.log("handlePlaceBetSuccess");
  };

  const handlePlaceBetClicked = (picks, isEmailMarketingAccepted) => {
    if (
      process.env.REACT_APP_SSO_DISABLED === "true" &&
      !localStorage.getItem("fiver_react_access_token")
    ) {
      dispatch(
        setAuth({
          placeBetData: {
            picks,
            activePickem,
            activePickemList,
            isEmailMarketingAccepted,
            profile,
          },
        })
      );
      history.push("/signup");
    } else {
      dispatch(
        placeBet({ translations, selections: picks, handlePlaceBetSuccess })
      );
    }
  };

  const onRulesClicked = () =>
    dispatch(openDrawer(process.env.REACT_APP_SLUG_RULES, translations.rules));

  const handleTermsAndConditionsClicked = () =>
    dispatch(
      openDrawer(process.env.REACT_APP_SLUG_TERMS, translations.termsConditions)
    );

  const handlePopupCancelClicked = () => {
    handleSetBetbarParent({
      isPopupVisible: false,
    });
  };

  useEffect(() => {
    if (activePickemList) {
      const latestPickem = activePickemList[0];

      dispatch(
        setBetbarParent({
          activePickem: latestPickem,
          isActivePickemInPlay: latestPickem?.status === "IN_PLAY",
          isActivePickemCompleted: latestPickem?.status === "COMPLETED",
          isActivePickemApproved: latestPickem?.status === "APPROVED",
        })
      );
    }
  }, [activePickemList]);

  return (
    <StyledWrapper
      needsPaddingTop={
        process.env.REACT_APP_PICKS_IS_HOW_TO_PLAY_ABOVE_BANNER === "true"
      }
    >
      {process.env.REACT_APP_PICKS_GAME_LOGO && (
        <StyledBanner
          src={createImageCdnLink(process.env.REACT_APP_PICKS_GAME_LOGO)}
        />
      )}
      <Picks
        hidePopularPick
        hideMakeYourPicks
        hasCheckboxes={process.env.REACT_APP_HAS_CONSENT_CHECKBOXES === "true"}
        onTermsAndConditionsClicked={handleTermsAndConditionsClicked}
        onRulesClicked={onRulesClicked}
        onPicksCleared={onPicksCleared}
        hasQuestionStatBelowQuestion={
          process.env.REACT_APP_PICKS_HAS_QUESTION_STAT_BELOW_QUESTION ===
          "true"
        }
        isMobileVerificationDisabled={
          process.env.REACT_APP_IS_MOBILE_VERIFICATION_DISABLED === "true"
        }
        isHowToPlayAboveBanner={
          process.env.REACT_APP_PICKS_IS_HOW_TO_PLAY_ABOVE_BANNER === "true"
        }
        isClearingPicks={isClearingPicks}
        isLoggedIn={isLoggedIn}
        isUsingAlternativeImages
        onPicksChanged={handlePicksChanged}
        onPlaceBetClicked={handlePlaceBetClicked}
        translations={translations}
        betbarParent={betbarParent}
        setBetbarParent={setBetbarParent}
        app={app}
        indexToShowGameBanner={
          process.env.REACT_APP_HIDE_TOTO_REFERENCES !== "true"
            ? activePickem?.questions?.length - 1
            : null
        }
        GameBanner={
          isOver24 &&
          (process.env.REACT_APP_BANNER_IMAGE ||
          process.env.REACT_APP_BANNER_LINK_IMAGE ? (
            <StyledTotoBannerLink
              href={process.env.REACT_APP_BANNER_LINK_URL}
              target="_blank"
              onClick={() => {
                window.xtremepush(
                  "tag",
                  "popup_banner_clicked",
                  JSON.stringify({
                    AppName: process.env.REACT_APP_TITLE,
                  })
                );
              }}
            >
              <StyledTotoBannerImage
                src={
                  process.env.REACT_APP_BANNER_LINK_IMAGE ||
                  createImageCdnLink(process.env.REACT_APP_BANNER_IMAGE)
                }
              />
            </StyledTotoBannerLink>
          ) : (
            <TotoGameBannerDick2022
              hasInvalidTotoScores={true}
              // textPlayResponsibly={translations.playResponsibly}
              textPlayResponsibly="Wat kost gokken jou? Stop op tijd. 18+"
              textPlaceBet={translations.register}
              // textBannerDefault={translations.totoGameBannerDefault}
              textBannerDefault="Jij bent de koning! Pak die kroon!"
              bannerText={translations.totoGameBanner}
              betAmount={null}
              winAmount={null}
            />
          ))
        }
        hasSocialShareButton={
          process.env.REACT_APP_HAS_SOCIAL_SHARE_BUTTON === "true"
        }
      />
      <TotoPopupBannerDick2022
        hasInvalidTotoScores={true}
        isVisible={isPopupVisible}
        onOverlayClicked={handlePopupCancelClicked}
        textTagline={translations.totoPopupBannerTagline}
        textToWin={translations.toWin}
        textNoThanks={translations.totoBannerCancel}
        textPlaceBet={translations.totoBannerPlaceBet}
        textPlayResponsibly="Wat kost gokken jou? Stop op tijd. 18+"
        textBannerDefault="Jij bent de koning! Pak die kroon!"
        betAmount={null}
        winAmount={null}
      />
    </StyledWrapper>
  );
};

export default Wrapper;
